import PropTypes from 'prop-types';
import React from 'react';
import formatAmount from '../shared/format_amount';
import classNames from 'classnames';
import MatchedPriceGuide from './matched_price_guide';
import { HashUtil, APIRequest, RecommendedPriceRange } from '@reverbdotcom/discovery-ui';

const PER_PAGE = 5;
const TRANSACTIONS_CLASS = 'pg-transactions-panel';
const SHOW_TRANSACTIONS_CLASS = 'see-pg-details';
const ENTER = 13;

class ListingFormCanonicalProductMatcher extends React.Component {
  static get propTypes() {
    return {
      inputsSelector: PropTypes.string.isRequired,
      conditionFieldSelector: PropTypes.string.isRequired,
      brandNewCondition: PropTypes.string.isRequired,
      showPhoto: PropTypes.bool,
      showOnLoad: PropTypes.bool,
      seed: PropTypes.object,
      dataServicesPriceEstimatesEnabled: PropTypes.bool,
      renderPGSectionOnly: PropTypes.bool,
    };
  }

  constructor(props) {
    super();

    this.state = {
      canonicalProduct: null,
      transactionsResponse: {},
      showPanel: false,
      lastParams: null,
      transactionsTracked: false,
      canonicalProductTracked: false,
      conditionSlug: $(props.conditionFieldSelector) && $(props.conditionFieldSelector).val(),
    };
  }

  componentDidMount() {
    this.fetchCPMatch();

    $(document).on('change', this.props.inputsSelector, () => {
      this.fetchCPMatch();
    });

    $(document).on('change', this.props.conditionFieldSelector, () => {
      this.setState({
        conditionSlug: $(this.props.conditionFieldSelector).val(),
      });
    });

    $(document).on('click', () => { this.setState({ showPanel: false }); });
    $(document).on(
      'click',
      `.${TRANSACTIONS_CLASS}, .${SHOW_TRANSACTIONS_CLASS}`,
      (e) => { e.stopPropagation(); },
    );
  }

  fetchCPMatch() {
    if (this.fieldsValid) {
      let urlParams = $(this.props.inputsSelector).serialize();

      if (this.props.seed.seedId && this.props.seed.seedType) {
        const seedParams = {
          seed_id: this.props.seed.seedId,
          seed_type: this.props.seed.seedType,
        };

        urlParams += `&${$.param({ seed: seedParams })}`;
      }

      if (this.state.lastParams !== urlParams) {
        this.setState({ lastParams: urlParams });

        APIRequest.V3.get(
          '/api/listings/similar_canonical_product',
          urlParams,
        ).done(data => this.updateCanonicalProduct(data));
      }
    } else {
      this.updateCanonicalProduct(null);
    }
  }

  get fieldsValid() {
    if ($(this.props.conditionFieldSelector).val() === this.props.brandNewCondition) {
      return false;
    }

    const requiredFields = Array
      .from($(this.props.inputsSelector))
      .filter(el => $(el).data('pg-match') === 'required');

    return requiredFields.length > 0 && requiredFields.every(el => $(el).val() && $(el).val().length > 0);
  }

  get hasTransactionsTotal() {
    return this.state.transactionsResponse && this.state.transactionsResponse.total;
  }

  get haveSoldRange() {
    if (!this.hasTransactionsTotal) { return null; }

    return I18n.t(
      'js.priceGuideMatcher.basedOnTransactions',
      { count: this.state.transactionsResponse.total },
    );
  }

  get hasPhoto() {
    return HashUtil.getSafely(this.state, 'canonicalProduct.has_photo');
  }

  get lowPrice() {
    return HashUtil.getSafely(this.state, 'canonicalProduct.estimated_value.price_low');
  }

  get highPrice() {
    return HashUtil.getSafely(this.state, 'canonicalProduct.estimated_value.price_high');
  }

  get hasEstimatedValues() {
    return this.lowPrice && this.highPrice;
  }

  togglePanel = (event) => {
    if (event) {
      event.preventDefault();
    }
    const currentShowPanel = this.state.showPanel;
    this.setState({ showPanel: !currentShowPanel });
    if (!this.state.transactionsResponse.transactions) {
      this.loadTransactions(
        this.state.canonicalProduct._links.transactions.href,
        { per_page: PER_PAGE },
      );
    }

    if (!(currentShowPanel || this.state.transactionsTracked)) {
      this.setState({ transactionsTracked: true });
    }
  };

  handleKeyDown = (event) => {
    if (event.keyCode === ENTER) {
      event.preventDefault();
      this.togglePanel();
    }
  };

  loadTransactions(url, options = {}) {
    APIRequest.V3.get(url, options).done((transactionsResponse) => {
      this.setState({ transactionsResponse });
    });
  }

  followPagination(url) {
    return (e) => {
      e.stopPropagation();
      this.setState({ transactionsResponse: { total: this.state.transactionsResponse.total } });
      this.loadTransactions(url);
    };
  }

  updateCanonicalProduct(newCanonicalProduct) {
    this.setState({ canonicalProduct: newCanonicalProduct, transactionsResponse: {} });
    if (!this.state.canonicalProduct) {
      $(this.pgMatchWrapper).fadeOut();
    } else {
      $(this.pgMatchWrapper).fadeIn();
      this.loadTransactions(newCanonicalProduct._links.transactions.href, { per_page: PER_PAGE });
      if (!this.state.canonicalProductTracked) {
        this.setState({ canonicalProductTracked: true });
      }
    }
  }

  renderPhoto() {
    if (!this.hasPhoto) {
      return null;
    }

    return (
      <div className="matched-pg__image">
        <img
          alt={this.state.canonicalProduct.title}
          src={this.state.canonicalProduct._links.photo.href}
          title={this.state.canonicalProduct.title}
        />
      </div>
    );
  }

  renderMatchedPriceRangeTable() {
    const lowPrice = formatAmount(this.state.canonicalProduct.estimated_value.price_low);
    const highPrice = formatAmount(this.state.canonicalProduct.estimated_value.price_high);

    return (
      <table className="matched-pg__table">
        <tbody>
          <tr>
            <th className="matched-pg__range matched-pg__range--below">
              {`< ${lowPrice}`}
              <span>{I18n.t('js.priceGuideMatcher.belowRange')}</span>
            </th>
            <th className="matched-pg__range matched-pg__range--fair">
              {lowPrice} - {highPrice}
              <span>{I18n.t('js.priceGuideMatcher.fairRange')}</span>
            </th>
            <th className="matched-pg__range matched-pg__range--above">
              {`> ${highPrice}`}
              <span>{I18n.t('js.priceGuideMatcher.aboveRange')}</span>
            </th>
          </tr>
        </tbody>
      </table>
    );
  }

  renderMatchTitle() {
    if (!this.state.canonicalProduct) { return null; }

    return (
      <h1 className="matched-pg__title">
        {I18n.t('js.priceGuideMatcher.priceRange', { title: this.state.canonicalProduct.title })}
      </h1>
    );
  }

  renderMatchSummary() {
    if (!this.state.canonicalProduct) { return null; }
    if (!this.hasEstimatedValues) { return null; }

    return (
      <div className="matched-pg">
        {this.props.showPhoto && this.renderPhoto()}
        <div className="matched-pg__data">
          {this.renderMatchTitle()}
          {this.renderMatchedPriceRangeTable()}
          {this.renderTransactionPanel()}
        </div>
      </div>
    );
  }

  renderPopoutMobileHeader() {
    return (
      <div className="panel-popout-mobile-header show-only-on-mobile">
        <div className="g-container">
          <div className="g-col-3" />
          <div className="g-col-6 align-center">
            <h4 className="heading-4">{I18n.t('js.priceGuideMatcher.mobile_title')}</h4>
          </div>
          <div className="g-col-3 align-right">
            <button
              className="gray big panel-popout-close-action"
              onClick={() => this.togglePanel()}
            >
              <span className="fa fa-times" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderTransactionPanel() {
    if (!this.state.canonicalProduct) { return null; }

    return (
      <div className="matched-pg__transactions panel-container">
        <span
          className={classNames('ml-half', 'matched-pg__toggle__transactions', SHOW_TRANSACTIONS_CLASS)}
          onClick={this.togglePanel}
          onKeyDown={this.handleKeyDown}
          role="button"
          tabIndex={0}
        >
          {I18n.t('js.priceGuideMatcher.seeTransactions')}
          <i className="fa fa-angle-down ml-half" />
        </span>
        <span className="matched-pg__toggle__transactions__count">{this.haveSoldRange}</span>
        {this.renderPanelContent()}
      </div>
    );
  }

  renderPanelContent() {
    if (!(this.state.canonicalProduct && this.state.showPanel)) { return false; }

    return (
      <div
        className={
          classNames(
            'panel-popout',
            'module-shadow',
            'pointer-top',
            TRANSACTIONS_CLASS,
            'panel-align-left',
            'pointer-left',
          )
        }
      >
        {this.renderPopoutMobileHeader()}
        <div className="panel-content">
          <MatchedPriceGuide
            transactions={this.state.transactionsResponse}
            followPagination={url => this.followPagination(url)}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.props.renderPGSectionOnly) {
      return (
        <section id="pg_match" className={`${!this.props.showOnLoad && 'hidden'} small`} ref={(div) => { this.pgMatchWrapper = div; }}>
          {this.renderMatchSummary()}
        </section>
      );
    }

    return (
      <>
        <RecommendedPriceRange
          canonicalProduct={this.state.canonicalProduct}
          conditionSlug={this.state.conditionSlug}
          transactionsPanel={this.renderTransactionPanel()}
          roundedBorder
        />
        {!this.props.dataServicesPriceEstimatesEnabled && (
          <section id="pg_match" className={`${!this.props.showOnLoad && 'hidden'} small`} ref={(div) => { this.pgMatchWrapper = div; }}>
            {this.renderMatchSummary()}
          </section>
        )}
      </>
    );
  }
}

ListingFormCanonicalProductMatcher.defaultProps = {
  showPhoto: true,
  showOnLoad: false,
  seed: {},
};

export default ListingFormCanonicalProductMatcher;
